import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import BulkImportExport from "../../components/BulkImportExport"
import { usePermissions } from "API/PermissionContext"

const Vehicles = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.VEHICLES
  const [vehicles, setVehicles] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [vehicleId, setVehicleId] = useState("")
  const [search, setSearch] = useState("")

  const fetchData = useCallback(async () => {
    try {
      const resp = await api.get("vehicles")
      setVehicles(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.delete("delete-vehicle/" + vehicleId); fetchData() } catch (e) { console.error(e) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-vehicles", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(vehicles.length > 0 && vehicles.every(p => n[p.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; vehicles.forEach(p => { items[p.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const filtered = useMemo(() => {
    if (!search) return vehicles
    const s = search.toLowerCase()
    return vehicles.filter(p =>
      (p.transporterName || p.transporter || "").toLowerCase().includes(s) ||
      (p.vehicleNumber || "").toLowerCase().includes(s) ||
      (p.driverName || "").toLowerCase().includes(s) ||
      (p.driverMobile || "").toLowerCase().includes(s)
    )
  }, [vehicles, search])

  const summaryCards = [
    { label: "Total Vehicles", value: vehicles.length, icon: "fa-truck-moving", color: "#6366f1" },
    { label: "Transporters", value: new Set(vehicles.map(v => v.transporterName || v.transporter).filter(Boolean)).size, icon: "fa-truck", color: "#0ea5e9" },
  ]

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && selectedCount > 0 && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i> <span className="badge bg-white text-danger ms-1">{selectedCount}</span>
          </button>
        )}
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={4}><h4>Vehicles</h4></Col>
            <Col md={8} style={{ textAlign: "right" }}>
              <Row>
                <Col md={6}>
                  <div className="input-group">
                    <div className="input-group-text"><i className="fas fa-search"></i></div>
                    <input type="text" onChange={e => setSearch(e.target.value)} value={search}
                      className="form-control" placeholder="Search by Vehicle, Transporter, Driver..." />
                  </div>
                </Col>
                <Col md={6} style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "flex-end" }}>
                  <BulkImportExport
                    data={vehicles}
                    columns={[
                      { key: "transporter", label: "Transporter ID", required: true },
                      { key: "vehicleNumber", label: "Vehicle Number", required: true },
                      { key: "driverName", label: "Driver Name", required: true },
                      { key: "driverMobile", label: "Driver Mobile", required: true },
                      { key: "vehicleType", label: "Vehicle Type" },
                      { key: "capacity", label: "Capacity (Ltrs)" },
                      { key: "insuranceNumber", label: "Insurance Number" },
                      { key: "insuranceExpiry", label: "Insurance Expiry" },
                    ]}
                    sampleData={[{ transporter: "1", vehicleNumber: "KA01AB1234", driverName: "Raju", driverMobile: "9876543210", vehicleType: "Truck", capacity: "5000" }]}
                    apiEndpoint="create-vehicle"
                    entityName="Vehicles"
                    onImportComplete={fetchData}
                    showExport={canExport(MID)}
                    showImport={canAdd(MID)}
                  />
                  {canAdd(MID) && (
                    <Link className="dashBtn" to="/add-vehicle">
                      <i className="fas fa-plus-square"></i> <b>Add New</b>
                    </Link>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px"
              }}>
                <i className={`fas ${card.icon}`} style={{ fontSize: "20px", color: card.color }}></i>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: 700, color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#94a3b8" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>S.No</th>
                <th>Transporter</th>
                <th>Vehicle Number</th>
                <th>Driver Name</th>
                <th>Driver Mobile</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dataLoaded ? (
                filtered.length > 0 ? filtered.map((data, i) => (
                  <tr key={data.id}>
                    <td><input type="checkbox" checked={!!checkedItems[data.id]} onChange={() => handleCheckbox(data.id)} /></td>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{data.transporterName || data.transporter}</td>
                    <td>{data.vehicleNumber || "—"}</td>
                    <td>{data.driverName || "—"}</td>
                    <td>{data.driverMobile || "—"}</td>
                    <td>
                      {canEdit(MID) && <Link title="Edit" to={"/edit-vehicle/" + data.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete" title="Delete"
                        onClick={() => { setVehicleId(data.id); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={7} className="text-center py-4"><i className="fas fa-truck-moving fa-2x text-muted mb-2 d-block"></i>No vehicles found</td></tr>
                )
              ) : (
                <tr><td colSpan={7}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Vehicle deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} vehicles?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Vehicles deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Vehicles
